import panzoom from 'panzoom';
export const enablePinchToZoomOnThisDiv = (divId: string) => {
    const elemToBeZoomed = document.getElementById(divId);
    let panzoomInstance = null;
    if (elemToBeZoomed) {
        panzoomInstance = panzoom(elemToBeZoomed, {
            pinchSpeed: 1,
            bounds: true,
            boundsPadding: 1,
            minZoom: 1,
            maxZoom: 3
        });

        // panzoomInstance.pause();
    }

    return panzoomInstance;
};
